module.exports = __webpack_public_path__ + "media/images/help/flow/eyecatch-truck-18894dae406cbf4d868d9f62f03adccd.svg";